import { render, staticRenderFns } from "./CreateOffer.vue?vue&type=template&id=0c95cbd6&scoped=true&"
import script from "./CreateOffer.vue?vue&type=script&lang=js&"
export * from "./CreateOffer.vue?vue&type=script&lang=js&"
import style0 from "./CreateOffer.vue?vue&type=style&index=0&id=0c95cbd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c95cbd6",
  null
  
)

export default component.exports